import { useState, useEffect, useMemo } from 'react';
import { ProjectAPI, Project } from '@brg/api';

// Кеш для загруженных проектов
const projectsCache = new Map<string, { projects: Project<'Global'>[] | null; loading: boolean; error: boolean }>();

/**
 * Хук для получения списка проектов с кешированием
 */
export const useGetProjectListByIds = (ids: string[]) => {
  // Создаем ключ кеша из отсортированных ids
  const cacheKey = useMemo(() => {
    if (!ids || ids.length === 0) return 'empty';
    return [...ids].sort().join(',');
  }, [ids]);

  const [projects, setProjects] = useState<Project<'Global'>[] | null>(() => {
    const cached = projectsCache.get(cacheKey);
    return cached?.projects || null;
  });
  const [loading, setLoading] = useState(() => {
    const cached = projectsCache.get(cacheKey);
    return cached?.loading || false;
  });
  const [error, setError] = useState(() => {
    const cached = projectsCache.get(cacheKey);
    return cached?.error || false;
  });

  useEffect(() => {
    if (!ids || ids?.length === 0) {
      setProjects([]);
      return;
    }

    // Проверяем кеш
    const cached = projectsCache.get(cacheKey);
    if (cached) {
      setProjects(cached.projects);
      setLoading(cached.loading);
      setError(cached.error);
      return;
    }

    // Если данных нет в кеше, загружаем
    setLoading(true);
    const cacheEntry = { projects: null, loading: true, error: false };
    projectsCache.set(cacheKey, cacheEntry);

    ProjectAPI.GetList({
      projectIds: ids,
      isLite: true,
      isContextIgnored: true,
      appNameIgnore: true,
      projectFilter: 2,
      projectStatus: [1, 7, 9, 10],
      orderByProjectIds: true
    })
      .then((r) => r.json())
      .then((r) => {
        const loadedProjects = r?.data || null;
        setProjects(loadedProjects);
        setLoading(false);
        projectsCache.set(cacheKey, { projects: loadedProjects, loading: false, error: false });
      })
      .catch((error) => {
        console.error(error);
        setError(true);
        setLoading(false);
        projectsCache.set(cacheKey, { projects: null, loading: false, error: true });
      });
  }, [cacheKey, ids]);

  return {
    projects,
    loading,
    error
  };
};
import { useState, useEffect, useMemo } from 'react';
import { ProjectAPI, Project } from '@brg/api';

// Кеш для загруженных проектов
const projectsCache = new Map<string, { projects: Project<'Global'>[] | null; loading: boolean; error: boolean }>();

/**
 * Хук для получения списка проектов с кешированием
 */
export const useGetProjectListByIds = (ids: string[]) => {
  // Создаем ключ кеша из отсортированных ids
  const cacheKey = useMemo(() => {
    if (!ids || ids.length === 0) return 'empty';
    return [...ids].sort().join(',');
  }, [ids]);

  const [projects, setProjects] = useState<Project<'Global'>[] | null>(() => {
    const cached = projectsCache.get(cacheKey);
    return cached?.projects || null;
  });
  const [loading, setLoading] = useState(() => {
    const cached = projectsCache.get(cacheKey);
    return cached?.loading || false;
  });
  const [error, setError] = useState(() => {
    const cached = projectsCache.get(cacheKey);
    return cached?.error || false;
  });

  useEffect(() => {
    if (!ids || ids?.length === 0) {
      setProjects([]);
      return;
    }

    // Проверяем кеш
    const cached = projectsCache.get(cacheKey);
    if (cached) {
      setProjects(cached.projects);
      setLoading(cached.loading);
      setError(cached.error);
      return;
    }

    // Если данных нет в кеше, загружаем
    setLoading(true);
    const cacheEntry = { projects: null, loading: true, error: false };
    projectsCache.set(cacheKey, cacheEntry);

    ProjectAPI.GetList({
      projectIds: ids,
      isLite: true,
      isContextIgnored: true,
      appNameIgnore: true,
      projectFilter: 2,
      projectStatus: [1, 7, 9, 10],
      orderByProjectIds: true
    })
      .then((r) => r.json())
      .then((r) => {
        const loadedProjects = r?.data || null;
        setProjects(loadedProjects);
        setLoading(false);
        projectsCache.set(cacheKey, { projects: loadedProjects, loading: false, error: false });
      })
      .catch((error) => {
        console.error(error);
        setError(true);
        setLoading(false);
        projectsCache.set(cacheKey, { projects: null, loading: false, error: true });
      });
  }, [cacheKey, ids]);

  return {
    projects,
    loading,
    error
  };
};
